import { API } from './../constants'
import authService from './auth.js'

let ventas = null
let puntosDeVenta = null
let seminarios = null
// let cantidadProductosVendidos = null
// let ventasTotales = null
// let totalFacturadoCarrito = null

const ventasService = {

  async traerServiciosTodosConStock () {
    const fetchResponse = await fetch(`${API}/servicios-stock`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    ventas = respuesta.data
    return [...ventas]
  },

  async traerVentasTodas () {
    const fetchResponse = await fetch(`${API}/ventas`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    ventas = respuesta.data
    return [...ventas]
  },

  async traerProductosVendidosEntregados () {
    const fetchResponse = await fetch(`${API}/ventas-lista-entregados`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },

  async traerProductosVendidosNoEntregados () {
    const fetchResponse = await fetch(`${API}/ventas-lista-no-entregados`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },

  async traerProductosVendidos () {
    const fetchResponse = await fetch(`${API}/ventas-totales`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
    // ventasTotales = respuesta.data
    // return [...ventasTotales]
  },
  async traerVentasRemerasConvencion2025 () {
    const fetchResponse = await fetch(`${API}/ventas-remeras-convencion-2025`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    ventas = respuesta.data
    return [...ventas]
  },
  async traerVentasKitsConvencion2025 () {
    const fetchResponse = await fetch(`${API}/ventas-kits-convencion-2025`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    ventas = respuesta.data
    return [...ventas]
  },
  async traerAlmuerzosConvencion2025 () {
    const fetchResponse = await fetch(`${API}/ventas-almuerzos-convencion-2025`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    ventas = respuesta.data
    return [...ventas]
  },
  async traerVentasMercadoPago () {
    const fetchResponse = await fetch(`${API}/ventas-mercado-pago`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    ventas = respuesta.data
    return [...ventas]
  },
  async traerVentaPorId (id) {
    const fetchResponse = await fetch(`${API}/venta/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
    // venta = respuesta.data
    // return [...venta]
  },

  async traerAsistenciaSeminariosPorAsociadoId (id) {
    const fetchResponse = await fetch(`${API}/asistencia-seminarios/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    seminarios = respuesta.data
    return [...seminarios]
  },
  async traerPosiblesPuntosDeEntregaParaVenta (id) {
    const fetchResponse = await fetch(`${API}/posibles_puntos_de_entrega_de_venta/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    puntosDeVenta = respuesta.data
    return [...puntosDeVenta]
  },
  crearVenta (data) {
    return fetch(`${API}/crear-venta`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(respuesta => {
        return { ...respuesta }
      })
  },
  crearEntrega (data) {
    return fetch(`${API}/crear-entrega-punto-de-venta`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(respuesta => {
        return { ...respuesta }
      })
  }

}

export default ventasService
